import ElementContent from '@/components/sections/builder/elements/body/text-with-icon/content';
import ElementSetting from '@/components/sections/builder/elements/body/text-with-icon/setting';
import Column from '@/components/sections/builder/elements/body/text-with-icon/column';
import { TextWithIconElementDataType } from '@/components/sections/builder/elements/body/text-with-icon/type';
import { Type } from 'lucide-react';
import { DEFAULT_THEME_COLOR_SCHEME } from '@/components/sections/builder/theme/color';

const defaultData: TextWithIconElementDataType = {
  name: 'Text With Icon',
  heading: '',
  headingSize: 'small',
  imageWidth: 'small',
  imagePosition: 'top-left',
  numberOfColumns: 4,
  columnAlignment: 'center',
  borderRadius: 8,
  borderStyle: 'none',
  titleAlign: 'left',
  padding: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  colorScheme: DEFAULT_THEME_COLOR_SCHEME,
};

export const ElementPreviewIcon = Type;

const defaultChildsDatas = [
  {
    name: 'Column',
    heading: 'Harga Khusus',
    description: 'Dapatkan harga khusus dengan pembelian jumlah besar',
    imageUrl:
      'https://dev-storage.jubelio.com/demo-c/images/jstorev2/8168e1b4-2f0e-4212-8eb2-5758124116af.png',
  },
  {
    name: 'Column',
    heading: 'Kustomisasi Produk',
    description: 'Desain produk yang unik dan sesuai kebutuhan Anda.',
    imageUrl:
      'https://dev-storage.jubelio.com/demo-c/images/jstorev2/71964f14-40d2-4eaf-9e44-8b378b01c867.png',
  },
  {
    name: 'Column',
    heading: 'Pickup or Delivery',
    description: 'Opsi pengiriman atau pengambilan barang di tempat.',
    imageUrl:
      'https://dev-storage.jubelio.com/demo-c/images/jstorev2/039416d3-c1cb-47bd-8fbf-0d81d5f421ac.png',
  },
  {
    name: 'Column',
    heading: 'Invoice',
    description: 'Tersedia invoice dan faktur pajak',
    imageUrl:
      'https://dev-storage.jubelio.com/demo-c/images/jstorev2/d47692ec-2bef-4863-a8c8-e4dbe7274625.png',
  },
];

const TextWithIcon = {
  type: 'text_with_icon',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: defaultChildsDatas.map((child) => ({
    ...Column,
    defaultData: child,
  })),
  childs: [Column],
};

export default TextWithIcon;
